export default "__VITE_ASSET__Clx1axwd__"